module.exports = "/_next/static/images/num-1-1271e1a2.png";